module.exports = ".selected-row{\r\n    background-color: #FFCA28  !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/scal360/activate-scal360-license/activate-scal360-license.component.css
// module id = 978
// module chunks = 1